import React, { useMemo } from "react";
import { UseFormReturn, useWatch } from "react-hook-form";
import { FormField } from "@/components/ui/form";
import { AgeSideSection } from "./AgeSideSection";
import { OfferFormValues } from "../calendar/schemas/offerFormSchema";
import { useGradeOptions } from "@/components/admin/locations/LocationFormSections/hooks/useGradeOptions";

interface Props {
  form: UseFormReturn<OfferFormValues>;
}

export const SessionAgeGroupOverrideFields: React.FC<Props> = ({ form }) => {
  const { gradeOptions } = useGradeOptions();
  const show = useWatch({ control: form.control, name: "overrideAges" });

  if (!show) return null;

  return (
    <div className="space-y-4">
      <div className="grid grid-cols-2 gap-8">
        <AgeSideSection
          form={form}
          isMin={true}
          ageYearsName={"minAgeInYearsOverride"}
          gradeKeyName={"minAgeGradeKeyOverride"}
          noteName={"minAgeNoteOverride"}
          showGradeAsPrimaryName={"showMinAgeGradeAsPrimaryOverride"}
          gradeOptions={gradeOptions}
        />
        <AgeSideSection
          form={form}
          isMin={false}
          ageYearsName={"maxAgeInYearsOverride"}
          gradeKeyName={"maxAgeGradeKeyOverride"}
          noteName={"maxAgeNoteOverride"}
          showGradeAsPrimaryName={"showMaxAgeGradeAsPrimaryOverride"}
          gradeOptions={gradeOptions}
        />
      </div>
    </div>
  );
};


